<div class="container" style="width: 68px; height: 63px;">
  <div class="gauge-wrapper">
    <svg class="semi-circle" width="68" height="34" viewBox="-4 0 76 40" preserveAspectRatio="xMidYMax">
      <defs>
        <linearGradient [attr.id]="'progressGradient-' + id" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="3%" stop-color="#FF0000" />     <!-- midpoint of 0–6 -->
          <stop offset="10%" stop-color="#FF2400" />    <!-- 7–13 -->
          <stop offset="17%" stop-color="#FF4700" />    <!-- 14–20 -->
          <stop offset="24%" stop-color="#FF6B00" />    <!-- 21–27 -->
          <stop offset="31%" stop-color="#FF8F00" />    <!-- 28–34 -->
          <stop offset="38%" stop-color="#FFB200" />    <!-- 35–41 -->
          <stop offset="45%" stop-color="#FFD600" />    <!-- 42–48 -->
          <stop offset="52%" stop-color="#FFFA00" />    <!-- 49–55 -->
          <stop offset="60%" stop-color="#E0FF00" />    <!-- 56–62 → centered at 60% -->
          <stop offset="67%" stop-color="#BDFF00" />    <!-- 63–69 -->
          <stop offset="74.5%" stop-color="#99FF00" />  <!-- 70–77 -->
          <stop offset="81%" stop-color="#75FF00" />    <!-- 78–84 -->
          <stop offset="88%" stop-color="#52FF00" />    <!-- 85–91 -->
          <stop offset="95%" stop-color="#2EFF00" />    <!-- 92–98 -->
          <stop offset="100%" stop-color="#00FF00" />   <!-- 99–100 -->
        </linearGradient>

        <filter id="inset-shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feComponentTransfer in=SourceAlpha>
            <feFuncA type="table" tableValues="1 0" />
          </feComponentTransfer>
          <feGaussianBlur stdDeviation="4"/>
          <feOffset dx="0" dy="0" result="offsetblur"/>
          <feFlood flood-color="rgb(0, 0, 0, 0.4)" result="color"/>
          <feComposite in2="offsetblur" operator="in"/>
          <feComposite in2="SourceAlpha" operator="in" />
          <feMerge>
            <feMergeNode in="SourceGraphic" />
            <feMergeNode />
          </feMerge>
        </filter>
      </defs>

      <!-- Debossed Arc with stronger inward shadow effect -->
     <!-- Show linear gradient bar  -->
      <path
      *ngIf = "showUnratedLabel"
      #shadowPath
      id="shadowPath"
      d="M0,40 a34,34 0 0,1 68,0"
      fill="none"
      [attr.stroke]="'url(#progressGradient-' + id + ')'"
      stroke-width="17"
      filter="url(#inset-shadow)"
      stroke-linecap="butt" />
  
        <path
        #shadowPath
        id="shadowPath"
        d="M0,40 a34,34 0 0,1 68,0"
        fill="none"
        stroke="#ffffff"  stroke-width="14"
        filter="url(#inset-shadow)" stroke-linecap="butt" />

        

        <path
          *ngIf="progress > 0"
          #progressPath
          d="M0,40 a34,34 0 0,1 68,0"
          [attr.stroke]="'url(#progressGradient-' + id + ')'"
          stroke-width="12"
          fill="none"
          stroke-linecap="butt" />
          
        <path
          *ngIf="initProgress < 0 || (progress == 0 && staffer.shifts_completed > 0)"
          id="zeroProgressPath"
          d="M0,40 a34,34 0 0,1 68,0"
          fill="none"
          stroke="#FF0000"
          stroke-width="12"
          stroke-linecap="butt"
        />

      <!-- Display Progress Text -->
      <text *ngIf = "showReliabilityLabel" x="34" y="45" text-anchor="middle" font-size="23" fill="#1D2C3A" class="score-text">
        {{ progress }}
      </text>

    </svg>

    <p *ngIf = "showReliabilityLabel" class="label" [class] = "{'reduce-top' : progress < 0}">Reliability score</p>
    <p *ngIf = "showUnratedLabel" class="unratd-labl" [class] = "{'reduce-top' : progress < 0}">Unrated</p>
  </div>

</div>
